package fr.manyverse.app.domain.validation

import fr.manyverse.app.domain.error.ValidationError

object InventoryItemValidator {

    const val MAX_NAME_LENGTH = 100
    const val MIN_QUANTITY = 1
    const val MAX_QUANTITY = 999

    fun validateName(name: String): Result<Unit> {
        return when {
            name.isBlank() -> Result.failure(ValidationError("Item name cannot be empty"))
            name.length > MAX_NAME_LENGTH -> Result.failure(ValidationError("Item name cannot exceed $MAX_NAME_LENGTH characters"))
            else -> Result.success(Unit)
        }
    }

    fun validateQuantity(quantity: Int): Result<Unit> {
        return when {
            quantity < MIN_QUANTITY -> Result.failure(ValidationError("Quantity must be between $MIN_QUANTITY and $MAX_QUANTITY"))
            quantity > MAX_QUANTITY -> Result.failure(ValidationError("Quantity must be between $MIN_QUANTITY and $MAX_QUANTITY"))
            else -> Result.success(Unit)
        }
    }

    fun validateForCreation(name: String, quantity: Int): Result<Unit> {
        validateName(name).onFailure { return Result.failure(it) }
        validateQuantity(quantity).onFailure { return Result.failure(it) }
        return Result.success(Unit)
    }
}
